import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { WindowRefService } from '../window-ref/window-ref.service';

@Injectable({
  providedIn: 'root',
})
export class WindowResizeService {
  constructor(private windowRefService: WindowRefService) {}

  DEBOUNCE_TIME = 500;

  get windowResizeObservable(): Observable<Event> {
    return fromEvent(this.windowRefService.nativeWindow, 'resize').pipe(
      debounceTime(this.DEBOUNCE_TIME),
    );
  }
}
